<template>
	<span
		v-if="countByCategoryTitle(categoryTitle) > 0"
		class="min-w-4 inline-flex h-4 items-center justify-center rounded-2xl bg-neutral-100 !px-1 !py-0.5 text-center text-[11px]/[18px] font-medium"
	>
		{{ countByCategoryTitle(categoryTitle) }}
	</span>
</template>
<script setup>
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'

const props = defineProps({
	categoryTitle: {
		type: String,
		required: true,
	},
})

const store = usePaletteBuilderStore()
const { countByCategoryTitle } = storeToRefs(store)
</script>
